import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export function BookStencil({ title = "Omslag kommer", className, style, }) {
    return (_jsxs("div", { className: classNames("cvr-book-placeholder", className), style: style, children: [_jsx("div", { className: "line" }), _jsx("div", { className: "line" }), _jsx("div", { className: "line" }), _jsx("div", { className: "edge" }), _jsx("div", { className: "title cvr-body-xs-tight", children: title })] }));
}
